'use client';

import { __rest, __awaiter, __assign, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import ApplyJobsForm from '../ApplyJobsForm/index.js';
import Popup from '../Popup/index.js';
import { ELanguage } from '../Utils/constants.js';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import { BodyContainer, AgreePrivacyPolicy, ErrorMessage, SystemAlert } from './style.css.js';
import { applySuccessLink, getJobUrlParams } from './helper.js';
import { applyJobs } from '../services/jobs/index.js';
import { translator } from '../Contexts/translator/helper.js';
import translations from './translations.js';
import { EApplyType } from '../services/resumes/types.js';
import { UNDEFINED_VALUE, SCREEN_WIDTH_MOBILE, INTERN_LEVEL, FRESHER_LEVEL, MANAGER_LEVEL, DIRECTOR_LEVEL, ADDITIONAL_HEIGHT_PRIVACY_POLICY, POLICY_ERROR } from './const.js';
import PopupWarning from '../PopupWarning/index.js';
import { getJobLevelList } from '../services/resumes/index.js';
import Alert from '../Alert/index.js';
import WarningIcon from '../Images/Warning/index.js';
import ModelError from '../services/model/index.js';
import CheckBox from '../CheckBox/index.js';
import { getPrivacyPolicy } from '../QuickApplyJobModal/service.js';
import { trackingABJobAnalysis } from '../services/tracking/applyJob.js';
import { getCookie } from '../Utils/cookie.js';

function ApplyJobsModal(_a) {
    var _this = this;
    var _b, _c;
    var userInfo = _a.userInfo, isOpen = _a.isOpen, accessToken = _a.accessToken, lang = _a.lang, jobInfo = _a.jobInfo, onClose = _a.onClose, baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, _d = _a.enableTracking, enableTracking = _d === void 0 ? false : _d, rest = __rest(_a, ["userInfo", "isOpen", "accessToken", "lang", "jobInfo", "onClose", "baseMsUrl", "baseUrl", "enableTracking"]);
    var _e = useState(false), isOpenPopupApply = _e[0], setIsOpenPopupApply = _e[1];
    var _f = useState(false), isOpenPopupWarning = _f[0], setIsOpenPopupWarning = _f[1];
    var _g = useState(null), jobLevels = _g[0], setJobLevels = _g[1];
    var _h = useState(false), isLoading = _h[0], setIsLoading = _h[1];
    var _j = useState(''), errorSystemMessage = _j[0], setErrorSystemMessage = _j[1];
    var applyJobsFormRef = useRef(null);
    var _k = useState([]), privacyPolicies = _k[0], setPrivacyPolicies = _k[1];
    var _l = useState(false), isCheckedPrivacyPolicy = _l[0], setCheckedPrivacyPolicy = _l[1];
    var _m = useState(false), isPrivacyError = _m[0], setPrivacyError = _m[1];
    var privacyErrorRef = useRef(null);
    var errorRef = useRef(null);
    var isMobile = typeof window !== UNDEFINED_VALUE ? window.innerWidth <= SCREEN_WIDTH_MOBILE : false;
    var t = function (txt) {
        var text = translator(txt, translations, lang !== null && lang !== void 0 ? lang : ELanguage.VI);
        return text;
    };
    var handleApplyJob = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var resumeType, body, jobSearchParams, apply, info, ABAnalysis, link, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!jobInfo)
                        return [2 /*return*/];
                    setIsLoading(true);
                    resumeType = ((_a = values.resume.type) === null || _a === void 0 ? void 0 : _a.includes(EApplyType.lastAttachment))
                        ? EApplyType.lastAttachment
                        : values.resume.type;
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 7, , 8]);
                    body = __assign(__assign(__assign({ 'jobIds[]': jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId, resumeId: (_c = (_b = values.resume) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : 0, resumeApply: resumeType, appliedType: resumeType, resumeFile: values.resume.type === EApplyType.newAttachment ? values.resumeFile : undefined }, (!values.coverLetter ? undefined : { coverLetter: values.coverLetter })), (values.resume.type === EApplyType.newAttachment && values.isReplaced
                        ? { isReplaced: !!values.isReplaced }
                        : undefined)), ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIp) ? { client_ip: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIp } : undefined));
                    jobSearchParams = getJobUrlParams((_d = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobUrl) !== null && _d !== void 0 ? _d : '');
                    return [4 /*yield*/, applyJobs(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken, body, lang, jobSearchParams)];
                case 2:
                    apply = _j.sent();
                    if (apply instanceof ModelError) {
                        setIsLoading(false);
                        setErrorSystemMessage((_f = (_e = apply.error) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : '');
                        return [2 /*return*/];
                    }
                    if (!(apply && (apply === null || apply === void 0 ? void 0 : apply["".concat(jobInfo.jobId)]))) return [3 /*break*/, 6];
                    info = apply === null || apply === void 0 ? void 0 : apply["".concat(jobInfo.jobId)];
                    if (!(info.code === 200)) return [3 /*break*/, 5];
                    ABAnalysis = getCookie('ABJobAnalysis');
                    if (!(enableTracking && ABAnalysis)) return [3 /*break*/, 4];
                    // Wait for tracking first then redirect later
                    return [4 /*yield*/, trackingABJobAnalysis(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', {
                            userId: (_g = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) !== null && _g !== void 0 ? _g : -1,
                            version: ABAnalysis,
                            action: 'apply'
                        })];
                case 3:
                    // Wait for tracking first then redirect later
                    _j.sent();
                    _j.label = 4;
                case 4:
                    link = applySuccessLink(baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', t, jobInfo);
                    setIsLoading(false);
                    setIsOpenPopupApply(false);
                    onClose && onClose();
                    link && window.location.assign(link);
                    return [3 /*break*/, 6];
                case 5:
                    setErrorSystemMessage((_h = info.message) !== null && _h !== void 0 ? _h : '');
                    setIsLoading(false);
                    _j.label = 6;
                case 6:
                    setIsLoading(false);
                    return [3 /*break*/, 8];
                case 7:
                    error_1 = _j.sent();
                    setIsLoading(false);
                    console.error(error_1);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var getJobLevels = function () { return __awaiter(_this, void 0, void 0, function () {
        var jobLevels_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getJobLevelList(lang, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '')];
                case 1:
                    jobLevels_1 = _a.sent();
                    if (jobLevels_1 && jobLevels_1.length > 0) {
                        setJobLevels(jobLevels_1);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleUserLevelName = function () {
        var level = jobLevels === null || jobLevels === void 0 ? void 0 : jobLevels.find(function (level) { return level.id === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId); });
        return lang === ELanguage.EN ? level === null || level === void 0 ? void 0 : level.attributes.nameEn : level === null || level === void 0 ? void 0 : level.attributes.nameVi;
    };
    var handleOpenPopup = function () {
        var isUserLowLevel = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId) === INTERN_LEVEL || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId) === FRESHER_LEVEL;
        var isJobHighLevel = (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelId) === MANAGER_LEVEL || (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelId) === DIRECTOR_LEVEL;
        var isAllowApplyJobs = !(isJobHighLevel && isUserLowLevel);
        if (isAllowApplyJobs) {
            setIsOpenPopupApply(isOpen);
        }
        else {
            setIsOpenPopupWarning(isOpen);
        }
    };
    var calculateFooterAdditionalHeight = function () {
        if (privacyPolicies.length <= 0) {
            return 0;
        }
        if (!isCheckedPrivacyPolicy && isPrivacyError) {
            return ADDITIONAL_HEIGHT_PRIVACY_POLICY + POLICY_ERROR;
        }
        return ADDITIONAL_HEIGHT_PRIVACY_POLICY;
    };
    useEffect(function () {
        if (isOpen && (!jobLevels || jobLevels.length < 1)) {
            getJobLevels();
        }
        handleOpenPopup();
    }, [isOpen]);
    useEffect(function () {
        if (!isOpen) {
            return;
        }
        if (!accessToken || accessToken === '') {
            return;
        }
        if (!(jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId)) {
            return;
        }
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var privacyPolicyResponse;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getPrivacyPolicy({
                            accessToken: accessToken,
                            body: {
                                jobIds: [(_a = jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId) !== null && _a !== void 0 ? _a : -1]
                            },
                            langCode: lang,
                            baseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : ''
                        })];
                    case 1:
                        privacyPolicyResponse = _b.sent();
                        setPrivacyPolicies(privacyPolicyResponse);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [isOpen, accessToken]);
    useEffect(function () {
        var _a;
        if (errorSystemMessage) {
            (_a = errorRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        }
    }, [errorSystemMessage]);
    useEffect(function () {
        var _a;
        if (!isPrivacyError) {
            return;
        }
        if (!privacyErrorRef.current) {
            return;
        }
        (_a = privacyErrorRef === null || privacyErrorRef === void 0 ? void 0 : privacyErrorRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    }, [isPrivacyError, privacyErrorRef]);
    return (React__default.createElement(React__default.Fragment, null,
        isOpenPopupWarning && (React__default.createElement(PopupWarning, { isShow: isOpenPopupWarning, langCode: lang, onClose: function () {
                setIsOpenPopupWarning(false);
                onClose && onClose();
                // onForceClose && onForceClose()
            }, onAccept: function () {
                setIsOpenPopupApply(true);
                setIsOpenPopupWarning(false);
                // onClose && onClose()
            }, title: t('Application confirmation'), warningTxt: t('Do you want to continue to apply?') },
            t('Your current job level'),
            ": ", (_b = handleUserLevelName()) !== null && _b !== void 0 ? _b : '',
            ' ',
            t('is not matching to this job requirement'),
            ".")),
        React__default.createElement(Popup, { isShow: isOpenPopupApply, lang: lang !== null && lang !== void 0 ? lang : ELanguage.VI, onClickOutside: function () {
                setIsOpenPopupApply(false);
                setPrivacyError(false);
                setErrorSystemMessage('');
                onClose && onClose();
            }, custom: {
                header: (React__default.createElement(Header, { langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI, job: jobInfo, onClose: function () {
                        setIsOpenPopupApply(false);
                        setPrivacyError(false);
                        setErrorSystemMessage('');
                        onClose && onClose();
                    } })),
                footer: (React__default.createElement(Footer, { lang: lang, isLoading: isLoading, isMobile: isMobile, t: t, privacyPolicies: privacyPolicies, privacyErrorState: [isPrivacyError, setPrivacyError], checkedPrivacyPolicyState: [isCheckedPrivacyPolicy, setCheckedPrivacyPolicy], onClick: function () {
                        var _a;
                        if (privacyPolicies.length > 0 && !isCheckedPrivacyPolicy) {
                            setPrivacyError(true);
                            return;
                        }
                        (_a = applyJobsFormRef.current) === null || _a === void 0 ? void 0 : _a.onSubmit();
                    } })),
                additionalFooterHeight: calculateFooterAdditionalHeight(),
                withDefaultBody: true
            } },
            React__default.createElement(BodyContainer, null,
                React__default.createElement(ApplyJobsForm, __assign({}, rest, { baseMsUrl: baseMsUrl, baseUrl: baseUrl, ref: applyJobsFormRef, accessToken: accessToken, lang: lang, popupOption: {
                        isInPopup: true
                    }, handleApply: handleApplyJob, jobInfo: jobInfo, userInfo: userInfo })),
                !isMobile && privacyPolicies.length > 0 && (React__default.createElement(AgreePrivacyPolicy, { isMobile: false },
                    React__default.createElement(CheckBox, { state: isCheckedPrivacyPolicy ? 'checked' : 'none', onCheckChange: function (value) {
                            setCheckedPrivacyPolicy(value === 'checked');
                            setPrivacyError(false);
                        }, label: React__default.createElement(React__default.Fragment, null,
                            React__default.createElement("span", null, t('I agree to the')),
                            ' ',
                            React__default.createElement("a", { target: '__blank', href: privacyPolicies && (privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies.length) > 0
                                    ? (_c = privacyPolicies[0]) === null || _c === void 0 ? void 0 : _c.fileUrl
                                    : '#', onClick: function (e) { return e.stopPropagation(); } }, t('Privacy Policy')),
                            ' ',
                            React__default.createElement("span", null, t('of this employer.')),
                            React__default.createElement("span", { className: 'required' }, "(*)")) }),
                    isPrivacyError && (React__default.createElement(ErrorMessage, { ref: privacyErrorRef }, t('Please tick the checkbox if you want to proceed.'))))),
                errorSystemMessage ? (React__default.createElement(Alert, { type: 'warning', style: { marginTop: 10 } },
                    React__default.createElement(SystemAlert, { ref: errorRef },
                        React__default.createElement(WarningIcon, null),
                        " ",
                        errorSystemMessage))) : null))));
}

export { ApplyJobsModal as default };
//# sourceMappingURL=index.js.map
